import { render } from "./SelectOption.vue?vue&type=template&id=9bc50416&scoped=true&ts=true"
import script from "./SelectOption.vue?vue&type=script&lang=ts"
export * from "./SelectOption.vue?vue&type=script&lang=ts"

import "./SelectOption.vue?vue&type=style&index=0&id=9bc50416&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bc50416"]])

export default __exports__